/** Decorative device glyphs shared by the HTML review shell and React pickers. */
export const VIEWPORT_ICON_PATHS = {
    responsive: 'M8 3H3v5M16 21h5v-5M3 3l7 7M21 21l-7-7',
    desktop: 'M4 3h16a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2ZM12 18v4M8 22h8',
    laptop: 'M5 3h14a2 2 0 0 1 2 2v11H3V5a2 2 0 0 1 2-2ZM3 16l-2 4h22l-2-4',
    tablet: 'M5 2h14a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2ZM12 18h.01',
    mobile: 'M7 2h10a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2ZM12 18h.01',
    frame: 'M4 2v20M20 2v20M2 4h20M2 20h20',
};
/** The device families used by the review and extension width presets. */
export function viewportIconForWidth(width) {
    if (width >= 1440)
        return 'desktop';
    if (width >= 1024)
        return 'laptop';
    if (width >= 768)
        return 'tablet';
    return 'mobile';
}
export function viewportIconMarkup(kind) {
    return `<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false" data-viewport-icon="${kind}" style="flex-shrink:0"><path d="${VIEWPORT_ICON_PATHS[kind]}"/></svg>`;
}
//# sourceMappingURL=viewportIcons.js.map